import { render, staticRenderFns } from "./ManterTabelionato.vue?vue&type=template&id=25acd03c&scoped=true&"
import script from "./ManterTabelionato.vue?vue&type=script&lang=js&"
export * from "./ManterTabelionato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25acd03c",
  null
  
)

export default component.exports